import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-source-name",
  templateUrl: "./source-name.component.html",
  styleUrls: ["./source-name.component.scss"],
})
export class SourceNameComponent implements OnInit {
  @Input()
  sourceId: string;
  sourceName: string;

  sourceNames = {
    certum: "laskutapuhelimella.fi",
    "internal-apixpoller-dev": "Apix (dev)",
    "internal-apixpoller": "Apix",
    ccweb: "laskurahoitus.rahoittaja.fi",
    console: "console",
  };

  constructor() {}

  ngOnInit(): void {
    this.sourceName = this.getSourceName(this.sourceId);
  }

  getSourceName(sourceId: string): string {
    if (!sourceId) {
      return "web";
    }
    const n = this.sourceNames[sourceId];
    if (n == null) {
      return sourceId;
    }
    return n;
  }
}
